// Маркер «идёт переключение организации», переживающий перезагрузку в рамках
// вкладки: оверлей на перезагруженном приложении поднимается из него сразу и
// висит, пока не подтянется новый профиль. Со временем жизни — чтобы протухший
// маркер (реавторизация зависла, вкладку потом перезагрузили вручную) не
// запирал приложение под непрозрачным экраном навсегда.
const STORAGE_KEY = 'organizationSwitchTarget';
const STALE_MS = 2 * 60 * 1000;

interface SwitchTargetMarker {
  name: string;
  ts: number;
}

export const readOrganizationSwitchTarget = (): string | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const marker = JSON.parse(raw) as SwitchTargetMarker;

    if (!marker?.name || Date.now() - marker.ts > STALE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return marker.name;
  } catch {
    return null;
  }
};

export const writeOrganizationSwitchTarget = (name: string): void => {
  try {
    const marker: SwitchTargetMarker = { name, ts: Date.now() };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(marker));
  } catch {
    /* sessionStorage может быть недоступен — не критично */
  }
};

export const clearOrganizationSwitchTarget = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* sessionStorage может быть недоступен — не критично */
  }
};
